module.exports = __webpack_public_path__ + "img/logo.ae03a7c5.png";